/**
 * Where focus goes in a layer that moves it itself — Popover, HoverCard: its
 * first stop, and the stop after it in the page. What can take focus is
 * use-modal-behavior.ts's focusableWithin, which every dialog counts its stops
 * by: that hook is mirrored byte for byte with the portal, so it cannot import
 * a module only this client has, and the client reads it instead — one list,
 * one filter.
 */

import { focusableWithin } from './use-modal-behavior';

export function firstFocusable(root: ParentNode): HTMLElement | undefined {
  return focusableWithin(root)[0];
}

/**
 * The first element after `from` in the page's order that can take focus,
 * leaving out anything inside `from` itself or inside `skip` — where Tab goes
 * next when focus leaves a layer that renders elsewhere than its trigger.
 */
export function focusableAfter(from: Element, skip?: Element | null): HTMLElement | undefined {
  return focusableWithin(document).find(
    (el) =>
      !from.contains(el) && !skip?.contains(el) && (from.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0,
  );
}
